import { render, staticRenderFns } from "./cleaningResources.vue?vue&type=template&id=059d3659&scoped=true&"
import script from "./cleaningResources.vue?vue&type=script&lang=js&"
export * from "./cleaningResources.vue?vue&type=script&lang=js&"
import style0 from "./cleaningResources.vue?vue&type=style&index=0&id=059d3659&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059d3659",
  null
  
)

export default component.exports